import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './Login/login/login.component';
import { RegistrationComponent } from './Login/registration/registration.component';
import { WelcomeComponent } from './User/welcome/welcome.component';
import { ForgotPasswordComponent } from './Login/forgot-password/forgot-password.component';
import { AuthGuard } from './security/auth.guard';
import { HomeComponent } from './shared/home/home.component';
import { LevelMonitoringComponent } from './Shared/home/level-monitoring/level-monitoring.component'; 
import { Router } from '@angular/router';
import { FlowMonitoringComponent } from './Shared/home/flow-monitoring/flow-monitoring.component';
import { ContactComponent } from './contact/contact.component';
import { BlogComponent } from './blog/blog.component';
import { IiotSoftwarePlatformComponent } from './Shared/home/iiot-software-platform/iiot-software-platform.component';
import { PredictiveMaintainanceComponent } from './Shared/home/predictive-maintainance/predictive-maintainance.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { EnergyMonitoringComponent } from './Shared/home/energy-monitoring/energy-monitoring.component';


const routes: Routes = [

  { path: 'login', component: LoginComponent },
  { path: 'http://localhost:4200/', redirectTo: "/home", pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'level-monitoring', component: LevelMonitoringComponent },
  { path: 'flow-monitoring', component: FlowMonitoringComponent },
  { path: 'iiot-software-platform', component: IiotSoftwarePlatformComponent },
  { path: 'predictive-maintainance', component: PredictiveMaintainanceComponent },
  { path: '', redirectTo: "/login", pathMatch: 'full' },
  { path:'contact', component: ContactComponent},
  { path:'contact', component: FlowMonitoringComponent},
  { path:'blog', component: BlogComponent},
  {path: 'levelmonitoring', component: LevelMonitoringComponent},
  {path: 'flowmonitoring', component: FlowMonitoringComponent},
  {path: 'iiotsoftwareplatform', component: IiotSoftwarePlatformComponent},
   { path: 'predictivemaintainance', component: PredictiveMaintainanceComponent },
   {path: 'about-us', component: AboutUsComponent},
   {path: 'energymonitoring', component: EnergyMonitoringComponent},



  {
    path: '', component: WelcomeComponent,
    children: [
      {
        path: 'admin', loadChildren: './Admin/admin.module#AdminModule', canActivate: [AuthGuard]
      },
      {
        path: 'common', loadChildren: './Common/common.module#CommonModule', canActivate: [AuthGuard]
      },
      {
        path: 'user', loadChildren: './User/user.module#UserModule', canActivate: [AuthGuard]
      }
    ]
  },
  { path: 'register', component: RegistrationComponent },
  { path: 'welcome', component: WelcomeComponent, canActivate: [AuthGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  companycode: string;
  url: string;

  constructor(private router: Router) {
    this.url = this.router['location']._platformLocation.location.origin;
    this.url = this.url.replace("http://", "");
    var array = this.url.split(".") // while run in local use ":" instead of "."

    if (array && array.length > 2) {
      this.companycode = array[0];
    }
    else {
      this.companycode = "admin";
    }
  }
}

